import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DocsIndexPage } from "@/features/docsindex/DocsIndexPage";

const search = z.object({
  node: z.string().optional(),
});

export const Route = createFileRoute("/_app/docs/")({
  validateSearch: search,
  component: () => <DocsIndexPage search={Route.useSearch()} />,
});
